import { Img, Show, Box } from "@chakra-ui/react";

import { VideoPlayer } from "../components/VideoPlayer";

import ScrollVelocity from "../animations/ScrollVelocity/ScrollVelocity";

import morning from "../media/morning.jpg";

export const Welcome = () => {
	return (
		<Box w="100%">
			<Show below="md">
				<Img
					h="auto"
					alt="Welcome"
					src={morning}
					objectFit="cover"
					w={{ base: "auto", md: "100vw" }}
					onContextMenu={(e) => e.preventDefault()}
				/>
			</Show>

			<Show above="md">
				<VideoPlayer />
			</Show>

			<Box py="2" bg="brand.contrast">
				<ScrollVelocity
					texts={["BASED IN MELBOURNE ✦ POLAROIDS NOW AVAILABLE ✦"]}
				/>
			</Box>
		</Box>
	);
};
